import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { MinimizeOutlined, CloseOutlined } from "@mui/icons-material";
import { Button, ButtonGroup } from "@mui/material";

export default class CloseToolbar extends Component {
    static propTypes = {
        onClose: PropTypes.func,
        onMinimize: PropTypes.func
    };



    render() {
        const { onClose, onMinimize } = this.props
        return (
            <IconWrapper style={this.props.style ? { ...this.props.style } : {}}>
                {onMinimize && <Icon>
                    <MinimizeOutlined onClick={e => onMinimize && onMinimize(e)} />
                </Icon>}
                {onClose && <Icon>
                    <CloseOutlined onClick={e => onClose && onClose(e)} />
                </Icon>}
            </IconWrapper>
        )
    }
}

const Icon = styled.div`
    height: 100%;
    
`

const IconWrapper = styled.div`
  display: flex;
  align-self: center;
  align-content: center;
  justify-content: flex-end;
  margin-right: 17px;
  width: 50%;
  cursor: pointer;
`;